// extracted by mini-css-extract-plugin
module.exports = {"list":"TeamList_list__T_GzL","item":"TeamList_item__cZCRB","link":"TeamList_link__zySA_","teamImg":"TeamList_teamImg__ZlIuY","teamName":"TeamList_teamName__9Od1K"};